/**
 * Retrieves the value of a specific cookie by name.
 *
 * @param {string} name - The name of the cookie to retrieve.
 * @returns {string | undefined} The cookie value if found, otherwise undefined.
 */
export function getCookie(name: string): string | undefined {
  const COOKIE_PARTS_EXPECTED = 2;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts?.length === COOKIE_PARTS_EXPECTED) {
    return parts.pop()?.split(';').shift();
  }

  return undefined;
}
